// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"e48fa0f0-168":"ce2752a68317c677f79f","e48fa0f0-794":"c4c7514873eef69a06e2","e48fa0f0-735":"5748744be7ea8b163b98","e48fa0f0-91":"5454db633537d86d0bda"}[chunkId] + ".js";
};